import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import Navbar from "../Core/Navbar";
import Footer from "../Core/Footer";


function Wishlist() {
  const navigate = useNavigate()
  const accessToken = localStorage.getItem("accessToken");
  const [wishProduct, setWishProduct] = useState([]);
  useEffect(() => {
    getWishlist();
  }, []);
  const getWishlist = async () => {
    try {
      const response = await api.get(
        `user_api/get-wishlist?access_token=${JSON.parse(accessToken)}`
      );

      if (response.data.status === "success") {
        const list = response.data.wishlist;
        setWishProduct(list);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  const removeWishlist = async id => {
    try {
      const response = await api.delete(
        `user_api/remove-wishlist?row_id=${id}`,
      );
      getWishlist();
      console.log(response.data);
    } catch (error) {
      console.log('Error fetching wishlist:', error);
    }
  };

  return (
    <div>
      <div  style={{justifyContent:"center", alignItems:"center", marginTop:20, marginBottom:20}}>
        {wishProduct?.length > 0 ? (
          <div
            className="product-grid"
            style={{ display: "flex", gap: "2rem", flexWrap: "wrap",justifyContent:"center"}}
          >
            {wishProduct.map((prod, i) => (
              <div
                key={i}
                className="product-card"
                style={{
                  height: "370px",
                  maxWidth:"250px",
                  minWidth:"200px",
                  boxSizing: "border-box",
                  flex: "0 0 20%",
                  position: "relative",
                }}
                onClick={() =>
                  navigate(`/Product_details_final/${prod.product_url}`)
                }
              >
                <div
                  className="product-image-container"
                  style={{
                    paddingTop: "0px",
                    backgroundColor: "white",
                    width: "100%",
                    height: "100%",
                    zIndex: 0,
                  }}
                >
                  <img
                    src={prod.product_image_path}
                    alt={prod.product_name}
                    className="product-image"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="product-info" style={{ padding: "0px" }}>
                  <h3
                    style={{
                      margin: "5px 0",
                      fontSize: "16px",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "60px",
                    }}
                  >
                    {prod.product_name}
                  </h3>
                  <p
                    className="product-price"
                    style={{
                      fontWeight: "bold",
                      color: "#e63946",
                    }}
                  >
                    AED{prod.selling_price}
                  </p>
                  
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    cursor: "pointer",
                    zIndex: 999,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeWishlist(prod.row_id)
                  }}
                >
                  <text style={{color:"black"}}>X</text>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="no-products-found"
            style={{
              textAlign: "center",
              padding: "40px",
              fontSize: "18px",
              color: "#666",
              width: "100%",
            }}
          >
            No products found in this category
          </div>
        )}
      </div>
    </div>
  );
}

export default Wishlist;
